import { useEffect, useRef } from 'react';

const useClickOutsideHandler = (onClickOutside: () => void) => {
    const ref = useRef<HTMLDivElement | null>();
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                onClickOutside();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () =>
            document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    return ref;
};

export default useClickOutsideHandler;
